import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import {
  getRequiredFields,
  removeEmptyFields,
  setEmptyFieldsToNull,
} from "@/lib/utils";
import { NAME, STATUS, START_DATE, END_DATE } from "../consts";
import { useIsMobile } from "@/hooks/use-mobile";
import { formValues, schema } from "./validations";
import { useEffect } from "react";
import { DEFAULT_FILTER } from "../consts";
import moment from "moment";

const useFilter = ({
  filterData,
  setFilterData,
  onCancel,
}: {
  filterData: any;
  setFilterData: React.Dispatch<React.SetStateAction<any>>;
  onCancel: () => void;
}) => {
  const isMobile = useIsMobile();

  const form = useForm<formValues>({
  resolver: zodResolver(schema),
  defaultValues: {
    [NAME]: "",
    [STATUS]: undefined, // ✅ boolean or undefined
    [START_DATE]: undefined,  
    [END_DATE] : undefined // ✅ Date object
  },
});


  useEffect(() => {
  if (filterData) {
    form.reset({
      [NAME]: filterData?.[NAME] || "",
      [STATUS]: filterData?.[STATUS], // ✅ don’t coerce to ""
      [START_DATE]: filterData?.[START_DATE] ? new Date(filterData[START_DATE]) : undefined, // ✅ ensure Date object
      [END_DATE]: filterData?.[END_DATE] ? new Date(filterData[END_DATE]) : undefined
    });
  }
}, [filterData]);


  const requiredFields = getRequiredFields(schema);

  const onSubmit = (data: formValues) => {
  const _data: Record<string, any> = {
    ...DEFAULT_FILTER,
    ...(data?.[NAME] ? { name: data[NAME] } : {}),
    ...(data?.[STATUS] !== undefined ? { isActive: data[STATUS] } : {}),
    ...(data?.[START_DATE] ? { startDate: moment(data[START_DATE]).format("YYYY-MM-DD") } : {}),
    ...(data?.[END_DATE] ?{ endDate: moment(data[END_DATE]).format("YYYY-MM-DD")} : {})
  };

  setFilterData(_data);
  onCancel();
};


  const onClear = () => {
    form.reset({
      [NAME]: "",
      [STATUS]: "",
      [START_DATE]: undefined,
      [END_DATE]: undefined,

    }); 
    setFilterData(DEFAULT_FILTER);
  };

  return {
    form,
    onSubmit,
    requiredFields,
    isMobile,
    onClear,
  };
};

export default useFilter;
